module.exports = __webpack_public_path__ + "static/media/SN_M251.6786edf4.jpg";